export default status => {
  if (status === 'ACTIVE') {
    return '#C9FFEF';
  } if (status === 'PROCESSED') {
    return '#FFEDCC';
  } return '#FFEDCC';
};
